import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authMe, authLogout, authRefresh } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = checking; object = logged in; false = anonymous
  const [user, setUser] = useState(null);

  const refreshFromServer = useCallback(async () => {
    try {
      const u = await authMe();
      setUser(u);
      return u;
    } catch (e) {
      // try refresh once if 401
      if (e?.response?.status === 401) {
        try {
          await authRefresh();
          const u2 = await authMe();
          setUser(u2);
          return u2;
        } catch {
          setUser(false);
          return null;
        }
      }
      setUser(false);
      return null;
    }
  }, []);

  useEffect(() => {
    refreshFromServer();
  }, [refreshFromServer]);

  const logout = async () => {
    await authLogout();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, logout, refresh: refreshFromServer }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
}
